/*! FloraVines agentic browsing + accessibility annotations */
(() => {
  const annotate = () => {
    const forms = [
      ['#ContactFooter', 'subscribe_footer_newsletter', 'Subscribe an email address to the FloraVines newsletter.'],
      ['#form__popup_newsletter', 'subscribe_popup_newsletter', 'Subscribe an email address to FloraVines updates from the newsletter popup.']
    ];

    forms.forEach(([selector, name, description]) => {
      const form = document.querySelector(selector);
      if (!form) return;
      form.setAttribute('toolname', name);
      form.setAttribute('tooldescription', description);
      const email = form.querySelector('input[type="email"]');
      if (email && !email.hasAttribute('toolparamdescription')) {
        email.setAttribute('toolparamdescription', 'Email address to subscribe to FloraVines updates');
      }
    });

    document.querySelectorAll('a.full-unstyled-link:not([aria-label])').forEach((link) => {
      if (link.textContent.trim()) return;
      const container = link.closest('article, li, .card, .banner, .slideshow__slide, .multicolumn-card') || link.parentElement;
      const heading = container && container.querySelector('h1, h2, h3, h4, [class*="heading"]');
      const label = heading && heading.textContent.trim();
      link.setAttribute('aria-label', label ? `View ${label}` : 'View linked collection or product');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', annotate, { once: true });
  else annotate();
})();
